import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PiechartRegularAi from './piechart-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PiechartRegularAi {...validProps} />;
}
SvgComponent.iconName = 'piechartRegularAi';

export const PiechartRegularAiIcon = svgIconWrapper(SvgComponent);
